<h1>{{ 'ErrorPageTitle' | localize }}</h1>
@if (code) {
  <h2>{{ code }}</h2>
}
@if (message) {
  <h2>{{ message }}</h2>
}
